export const utmParams = (): Record<string, string> => {
  if (typeof window === 'undefined') return {};

  const utmParams: Record<string, string> = {};

  new URLSearchParams(window.location.search).forEach((value, key) => {
    if (key.startsWith('utm_')) {
      utmParams[key.substring(4)] = value;
    }
  });

  return utmParams;
};
